import { TreeNode } from '../route-builder';

export const MercerStandingModule = {
  segment: 'mercer-standing',
  children: {
    MercerStandingListViewComponent: { segment: 'list-view', params: ['filter', 'tags'] }
  }
} as const satisfies TreeNode;
